<template>
<div id="FAQs">
<!--  <div class="layer"></div>-->
  <div class="question-header">
    <div :class="this.$lang === 'ar' ? 'bold-ar' : 'bold-en'">{{$t('supportMenu.faq')}}</div>
  </div>
  <div v-if="loadTabs" class="full-screen">
    <Loader :class="loadTabs && 'pb-10'" />
  </div>
  <div v-if="error" class="full-screen">
    <Error />
  </div>
  <div v-if="tabs.length > 0 && !loadTabs" class="tabsContainer">
    <v-tabs
      v-model="tab"
      background-color="#FFFFFF"
      color="#1D1D1D"
      grow
      class="test"
      centered
      show-arrows
      :class="[this.$lang === 'ar' ? 'left-dir' : 'left-dir', 'question-tabs']"
    >
      <v-tabs-slider color="#FFCB05" ></v-tabs-slider>
      <v-tab ref="tab"
             v-for="(item, index) in tabs" :key="index"> {{item}}
      </v-tab>
    </v-tabs>
  </div>
  <v-tabs-items v-model="tab" :touchless="true">
    <v-tab-item  v-for="(item, i) in tabs" :key="i">
      <div class="question-window">
<!--        <div v-if="$store.state.window > 500 && tabs.length > 0 && !loadTabs" class="question-background-circle"></div>-->
        <div v-if="loadData || errorData" style="height: 300px" class="response-handle">
          <Loader v-if="loadData" />
          <Error v-if="errorData" />
        </div>
<!--        <Loader v-if="loadData" />-->
<!--        <Error v-if="errorData" />-->
        <div class="content">
          <div :class="[index !== data[tab].info.length -1 ? 'question-content-border' : '','question-content']" v-for="(info, index) in data[tab].info" :key="index">
            <support-content :tabChange="tabChange" :index="index" :type="type" :data="info" />
          </div>
          <div v-if="data[tab].info.length < data[tab].totalElements" @click="handleFetchMore" :class="[lang === 'ar' ? 'flex-row-reverse' : '', 'load-btn']">
            <div v-if="loading" class="spinner-border text-dark" role="status"></div>
            <div v-if="!loading" :class="[lang ==='ar' ? 'bold-italic-ar' : 'bold-italic-en','px-1']"> {{$t('serviceCenter.btn')}} </div>
            <div v-if="!loading" class="px-1"> <img class="btn-arrows" src="../../assets/icons/down-arrow.svg"></div>
          </div>
        </div>
      </div>
    </v-tab-item>
  </v-tabs-items>
</div>
</template>

<script>
import SupportContent from './SupportContent'
import FaqCategoryRepository from '../../repositories/FaqCategoryRepository'
import FaqsRepository from '../../repositories/FaqsRepository'
import Loader from '../../components/LoaderBtn/Loader'
import Error from '../../components/errorHandle/Error'
import $ from 'jquery'
export default {
  name: 'FAQs',
  components: { SupportContent, Loader, Error },
  data () {
    return {
      faqCategoryRepo: new FaqCategoryRepository(),
      faqRepo: new FaqsRepository(),
      tab: 0,
      lang: this.$lang,
      type: 'faq',
      tabs: [],
      tabIds: [],
      data: [{ info: [], page: 0, totalElements: 0 }],
      page: 0,
      size: 4,
      temp: '',
      loading: false,
      totalElements: 0,
      visitedTabs: [],
      tabChange: 0,
      loadTabs: false,
      loadData: false,
      error: false,
      errorData: false
    }
  },
  watch: {
    async tab (val) {
      this.tabChange++
      const page = this.page
      if (!this.visitedTabs.includes(val)) { // check if this tab data fetched before
        // this.page = 0
        const url = this.tabIds[val] // save the id of the tab in separated folder
        this.temp = val // save tab value in temp
        // this.data = []
        // this.totalElements = 0
        try {
          this.loadData = true // start loader button
          const response = await this.faqRepo.getParamsById(url, page, this.size)
          if (response.status === 200) {
            this.visitedTabs.push(val) // if the data fetched successfully add the tab value to the fetched tabs
            this.data[val].info = []
            for (let i = 0; i < response.data.data.length; i++) {
              this.data[val].info.push({ title: response.data.data[i].question, desc: response.data.data[i].answer }) // insert the data in the array
            }
            this.style()
            this.data[val].totalElements = response.data.totalElements // set the total elements
          } else {
            this.errorData = true
          }
        } catch (e) {
          this.errorData = true
          this.loadData = false
          return e
        }
      }
      this.loadData = false // stop loader
    }
  },
  created () {
    this.style()
    this.handleCategories()
  },
  mounted () {
  },
  methods: {
    style () {
      if (this.$lang === 'ar') {
        $('.tabsContainer').css('transform', 'rotateY(180deg)')
        $('.question-tabs .v-tab').css('transform', 'rotateY(180deg)')
        $('#FAQs .tabsContainer .theme--light.v-tabs > .v-tabs-bar').addClass('arabicPadding')
        $('.v-tab').css('direction', 'rtl')
      } else {
        $('.v-tab').css('direction', 'ltr')
      }
    },
    async handleCategories () {
      this.tabs = []
      this.loadTabs = true // start the loader while fetching the categories data
      try {
        const response = await this.faqCategoryRepo.get()
        if (response.status === 200) {
          for (let i = 0; i < response.data.length; i++) {
            this.tabs.push(response.data[i].name) // set the titles of the categories to display the name for users
            this.tabIds.push(response.data[i].id) // set the id of the categories at this array (ps: the item in index 0 will match the id in index 0 in this array)
            this.data.push({ info: [], page: 0, totalElements: 0 }) // each element will has a specific page value and total elements
          }
          // this.data = []
          this.loadTabs = false
          const url = this.tabIds[0]
          this.loadData = true
          setTimeout(() => {
            this.style()
            this.$forceUpdate()
          })
          try {
            const response = await this.faqRepo.getParamsById(url, this.page, this.size) // fetch the data of the first tab
            if (response.status === 200) {
              this.data[0].info = []
              for (let i = 0; i < response.data.data.length; i++) {
                this.data[0].info.push({ title: response.data.data[i].question, desc: response.data.data[i].answer })
              }
              this.data[0].totalElements = response.data.totalElements
              this.visitedTabs.push(0)
            } else {
              this.errorData = true
            }
          } catch (e) {
            this.errorData = true
            return e
          }
          this.loadData = false
        } else {
          this.loadTabs = false
          this.error = true
        }
      } catch (e) {
        this.loadTabs = false
        this.error = true
        return e
      }
      this.loadTabs = false
      this.style()
    },
    async handleFetchMore () {
      const tab = this.tab
      const url = this.tabIds[tab]
      this.data[tab].page += 1
      this.loading = true
      try {
        const response = await this.faqRepo.getParamsById(url, this.data[tab].page, this.size)
        if (response.status === 200) {
          for (let i = 0; i < response.data.data.length; i++) {
            this.data[tab].info.push({ title: response.data.data[i].question, desc: response.data.data[i].answer })
          }
        }
      } catch (e) {
        return e
      }
      this.loading = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import "src/assets/sass/main";
.full-screen{
  min-height: calc(100vh - (170px + 80px + 285.6px));
  .loader,
  .error-container{
    min-height: calc(100vh - (170px + 80px + 285.6px)) !important;
  }
}
#FAQs{
  min-height: calc(100vh - (160px + 285.6px));
  .tabsContainer {
    height: 50px;
  }
  background: #f2f2f2;
  .loader,
  .error-container{
    min-height: calc(100vh - (160px + 80px + 285.6px)) !important;
  }
  .v-tabs {
    height: 50px !important
  }
  .theme--light.v-tabs-items{
    background: #f2f2f2;
  }
  .tabsContainer{
    box-shadow: 0 15px 25px rgba(0, 0, 0, 0.05);
    position: relative;
    z-index: 1;
  }
}
//.layer{
//  height: 100%;
//  width: 100%;
//  position: absolute;
//  background-image: url("../../assets/images/pure-background-circles.png");
//  background-position: left;
//  left: -230px;
//  z-index: -1;
//}
.arabicTabContainer{
  direction: ltr;
  transform: rotateY(180deg);
}
.question-header{
  height: 80px;
  background: #f2f2f2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  color: $--yellow;
}
.question-window{
  width: 100vw;
  background-color: rgba(242,242,242,.75);
  backdrop-filter: blur(25px);
  position: relative;
  min-height: calc(100vh - (160px + 285.6px + 80px + 50px ));
  background-image: url("../../assets/images/pure-background-circles.png");
  background-position-x: -15%
}
//.question-background-circle{
//  height: 100%;
//  width: 100%;
//  position: absolute;
//  background-image: url("../../assets/images/pure-background-circles.png");
//  background-position: top left;
//  left: -230px;
//  z-index: -1;
//}
.question-content{
  width: 70%;
  margin: 0 auto;
}
.content{
  padding: 2.5rem 0;
  margin: 0 auto;
}
.question-content-border{
  border-bottom: 1.5px solid $--yellow;
}
.content-border{
  border-bottom: 1.5px solid $--yellow ;
}
.load-btn{
  margin-top: 20px;
}
@media (max-width: 1000px) {
  //.question-background-circle{
  //  left: -300px;
  //}
}
@media (max-width: 900px) {
  .question-content{
    width: 80%;
  }
  .question-window{
    background-position-x: -50%
  }
}
@media (max-width: 550px) {
  .question-content{
    width: 95%;
  }
  .question-window{
    background-image: none
  }
  .content{
    width: 95% !important;
  }
}
</style>
<style>
.v-tab{
  font-size: 10px !important;
  color: #707070 !important;
}
.v-tab.v-tab--active{
  color: #FFCB05 !important;
  font-style: italic ;
  font-family: Mtn-arabic-bold !important;
}
.v-tabs.question-tabs.v-tabs--centered.v-tabs--grow.theme--light{
  background: rgba(242,242,242, .3);
  border-bottom: 2px solid #fff;
  border-top: 2px solid #fff;
}
  #FAQs .v-tabs-slider-wrapper{
    height: 2.5px !important;
    bottom: 2px !important;
  }
</style>
<style lang="scss" scoped>
@media (max-width: 1000px) {
  #FAQs{
    min-height: calc(100vh - (170px + 392.2px));
    .loader,
    .error-container{
      min-height: calc(100vh - (170px + 392.2px)) !important;
    }
  }
  .full-screen,
  .loader,
  .error-container{
    min-height: calc(100vh - (170px + 392.2px)) !important;
  }
}
@media (max-width: 575px) {
  #FAQs{
    min-height: calc(100vh - (170px + 392.2px));
    .loader,
    .error-container{
      min-height: calc(100vh - (170px + 392.2px)) !important;
    }
  }
  .full-screen,
  .loader,
  error-container{
    min-height: calc(100vh - (170px + 392.2px)) !important;
  }
}
#FAQs{
  .theme--light.v-tabs > .v-tabs-bar .v-tab:not(.v-tab--active){
    color: rgba(29, 29, 29, 0.6) !important;
  }
  .v-tabs{
    height: 100%;
    border-bottom: 2px solid #ffffff;
  }
  .v-tab{
    font-size: 12px !important;
    /*border-bottom: 2px solid #ffffff;*/
    text-transform: capitalize;
  }
  .v-tab.v-tab--active{
    color: #FFCB05;
  }
  .v-window.v-item-group.theme--light.v-tabs-items{
    background: transparent;
  }
  .v-tabs{
    position: relative;
  }
}
#FAQs .v-tabs{
  padding: 0 4vw;
  display: flex;
  justify-content: center;
}
</style>
<style lang="scss">
  #FAQs {
  .v-tabs{
    position: relative;
  }
   .theme--light.v-tabs > .v-tabs-bar {
    position: absolute !important;
    top: 0.1px !important;
  }
  .v-tab{
    margin: 0 3vw;
  }
  }
  #FAQs .tabsContainer .theme--light.v-tabs > .v-tabs-bar {
    padding: 0 3vw 0 4vw;
  }
  @media (max-width: 450px) {
    #FAQs .tabsContainer .theme--light.v-tabs > .v-tabs-bar {
      padding: 0 1.5vw 0 4vw;
    }
  }
  #FAQs .tabsContainer .arabicPadding {
    padding: 0 5vw 0 2vw !important;
  }

</style>
